/**
 * Kuteerr Quick View
 * Fetches /products/HANDLE.js  →  populates modal  →  Cart API add
 * No dependencies. Vanilla JS.
 */
(function () {
  'use strict';

  var modal      = document.getElementById('qvModal');
  var backdrop   = document.getElementById('qvBackdrop');
  var closeBtn   = document.getElementById('qvClose');
  var qvImg      = document.getElementById('qvImg');
  var qvSkeleton = document.getElementById('qvSkeleton');
  var qvThumbs   = document.getElementById('qvThumbs');
  var qvLoading  = document.getElementById('qvLoading');
  var qvContent  = document.getElementById('qvContent');
  var qvCta      = document.getElementById('qvCta');
  var qvCraft    = document.getElementById('qvCraft');
  var qvName     = document.getElementById('qvName');
  var qvDesc     = document.getElementById('qvDesc');
  var qvPrice    = document.getElementById('qvPrice');
  var qvLink     = document.getElementById('qvLink');
  var qvWhatsApp = document.getElementById('qvWhatsApp');
  var qvAtcBtn   = document.getElementById('qvAtcBtn');
  var qvAtcLabel = document.getElementById('qvAtcLabel');
  var qvVariants = document.getElementById('qvVariants');
  var qvVarBtns  = document.getElementById('qvVariantBtns');

  if (!modal) return; /* guard: not on collection page */

  var currentVariantId = null;
  var currentProduct   = null;

  /* ── OPEN ─────────────────────────────────────────────── */
  function openQV(handle) {
    if (!handle) return;
    resetModal();
    modal.classList.add('open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    fetch('/products/' + handle + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('Product not found');
        return r.json();
      })
      .then(function (product) {
        currentProduct = product;
        populateModal(product);
      })
      .catch(function () {
        if (qvLoading) qvLoading.innerHTML =
          '<p style="color:rgba(255,231,196,.4);font-size:.85rem">Unable to load product.</p>';
      });
  }

  /* ── POPULATE ─────────────────────────────────────────── */
  function populateModal(p) {
    var variant = p.variants[0];
    currentVariantId = variant.id;

    /* Image */
    if (qvSkeleton) qvSkeleton.style.display = 'none';
    if (qvImg) {
      qvImg.src   = p.featured_image
        ? p.featured_image.replace(/(\.\w+)$/, '_600x$1')
        : '';
      qvImg.alt   = p.title;
      qvImg.style.display = 'block';
    }

    /* Thumbnail strip (up to 4 images) */
    if (qvThumbs && p.images && p.images.length > 1) {
      var frag = document.createDocumentFragment();
      p.images.slice(0, 4).forEach(function (img, i) {
        var btn = document.createElement('button');
        btn.className = 'qv-thumb' + (i === 0 ? ' active' : '');
        btn.style.backgroundImage = 'url(' + img.src.replace(/(\.\w+)$/, '_120x$1') + ')';
        btn.addEventListener('click', function () {
          qvImg.src = img.src.replace(/(\.\w+)$/, '_600x$1');
          qvThumbs.querySelectorAll('.qv-thumb').forEach(function (t) {
            t.classList.remove('active');
          });
          btn.classList.add('active');
        });
        frag.appendChild(btn);
      });
      qvThumbs.innerHTML = '';
      qvThumbs.appendChild(frag);
    }

    /* Text */
    if (qvCraft)  qvCraft.textContent  = p.type || p.vendor || '';
    if (qvName)   qvName.textContent   = p.title;
    if (qvDesc)   qvDesc.textContent   = (p.description || '')
      .replace(/<[^>]+>/g, '').trim().slice(0, 220)
      + (p.description.length > 220 ? '…' : '');

    /* Price */
    if (qvPrice) {
      var priceHtml = '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceHtml =
          '<span style="color:#d4a843">₹' + fmt(variant.price) + '</span>' +
          ' <span style="font-size:1rem;color:rgba(255,231,196,.3);text-decoration:line-through">₹' +
          fmt(variant.compare_at_price) + '</span>';
      } else if (p.price_varies) {
        priceHtml = '<span style="font-size:.9rem;color:rgba(255,231,196,.4)">From</span> ' +
          '<span style="color:#d4a843">₹' + fmt(p.price_min) + '</span>';
      } else {
        priceHtml = '<span>₹' + fmt(variant.price) + '</span>';
      }
      qvPrice.innerHTML = priceHtml;
    }

    /* Links */
    if (qvLink)     qvLink.href     = '/products/' + p.handle;
    if (qvAtcBtn)   qvAtcBtn.dataset.variantId = variant.id;
    if (qvWhatsApp) {
      qvWhatsApp.href = qvWhatsApp.href.split('text=')[0] +
        'text=' + encodeURIComponent('Hi, I am interested in ' + p.title);
    }

    /* Variants (only if more than default) */
    if (qvVariants && qvVarBtns && p.variants.length > 1 &&
        !p.has_only_default_variant) {
      qvVarBtns.innerHTML = '';
      var varFrag = document.createDocumentFragment();
      p.variants.forEach(function (v) {
        var btn = document.createElement('button');
        btn.className = 'qv-var-btn' + (v.id === variant.id ? ' active' : '');
        btn.textContent = v.title;
        btn.disabled    = !v.available;
        btn.addEventListener('click', function () {
          currentVariantId = v.id;
          if (qvAtcBtn) qvAtcBtn.dataset.variantId = v.id;
          qvVarBtns.querySelectorAll('.qv-var-btn').forEach(function (b) {
            b.classList.remove('active');
          });
          btn.classList.add('active');
          /* Update price for selected variant */
          if (qvPrice) {
            qvPrice.innerHTML = '<span>₹' + fmt(v.price) + '</span>';
          }
        });
        varFrag.appendChild(btn);
      });
      qvVarBtns.appendChild(varFrag);
      qvVariants.style.display = 'block';
    }

    /* Show content, hide skeleton */
    if (qvLoading) qvLoading.style.display  = 'none';
    if (qvContent) qvContent.style.display  = 'block';
    if (qvCta)     qvCta.style.display      = 'flex';
    if (qvCta)     qvCta.style.flexDirection = 'column';
    if (qvCta)     qvCta.style.gap          = '.75rem';
  }

  /* ── CLOSE ────────────────────────────────────────────── */
  function closeQV() {
    modal.classList.remove('open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function resetModal() {
    if (qvLoading) { qvLoading.style.display = 'block'; qvLoading.innerHTML =
      '<div class="qv-skel-line w-1/3 mb-2"></div>' +
      '<div class="qv-skel-line w-2/3 mb-1" style="height:1.8rem"></div>' +
      '<div class="qv-skel-line w-full mb-1"></div>' +
      '<div class="qv-skel-line w-5/6"></div>'; }
    if (qvContent) qvContent.style.display  = 'none';
    if (qvCta)     qvCta.style.display      = 'none';
    if (qvImg)   { qvImg.src = ''; qvImg.style.display = 'none'; }
    if (qvSkeleton) qvSkeleton.style.display = 'block';
    if (qvThumbs)   qvThumbs.innerHTML = '';
    if (qvVarBtns)  qvVarBtns.innerHTML = '';
    if (qvVariants) qvVariants.style.display = 'none';
    if (qvAtcLabel) qvAtcLabel.textContent = 'Add to Bag';
    if (qvAtcBtn) {
      qvAtcBtn.disabled = false;
      qvAtcBtn.classList.remove('qv-atc-success', 'qv-atc-loading');
    }
    currentVariantId = null;
    currentProduct   = null;
  }

  /* ── ADD TO CART ──────────────────────────────────────── */
  if (qvAtcBtn) {
    qvAtcBtn.addEventListener('click', function () {
      var varId = parseInt(qvAtcBtn.dataset.variantId, 10);
      if (!varId) return;

      qvAtcBtn.disabled  = true;
      qvAtcBtn.classList.add('qv-atc-loading');
      if (qvAtcLabel) qvAtcLabel.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body:    JSON.stringify({ id: varId, quantity: 1 }),
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        qvAtcBtn.classList.remove('qv-atc-loading');
        qvAtcBtn.classList.add('qv-atc-success');
        if (qvAtcLabel) qvAtcLabel.textContent = 'Added ✓';
        document.dispatchEvent(new CustomEvent('kuteerr:cart:updated', { detail: { openDrawer: true } }));

        /* Update cart count bubble (works with any header cart icon) */
        // fetch('/cart.js')
        //   .then(function (r) { return r.json(); })
        //   .then(function (cart) {
        //     var countEls = document.querySelectorAll('[data-cart-count]');
        //     countEls.forEach(function (el) {
        //       el.textContent = cart.item_count;
        //       el.classList.toggle('hidden', cart.item_count === 0);
        //     });
        //   });

        setTimeout(closeQV, 1400);
      })
      .catch(function () {
        qvAtcBtn.disabled = false;
        qvAtcBtn.classList.remove('qv-atc-loading');
        if (qvAtcLabel) qvAtcLabel.textContent = 'Try Again';
      });
    });
  }

  /* ── EVENT LISTENERS ──────────────────────────────────── */
  if (closeBtn)  closeBtn.addEventListener('click', closeQV);
  if (backdrop)  backdrop.addEventListener('click', closeQV);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('open')) closeQV();
  });

  /* Delegate Quick View clicks — works for dynamically rendered cards */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-view]');
    if (btn) openQV(btn.dataset.quickView);
  });

  /* ── HELPERS ──────────────────────────────────────────── */
  function fmt(cents) {
    return (cents / 100).toLocaleString('en-IN');
  }

  /* ── EXPOSE (for any legacy onclick="openQV()" calls) ─── */
  window.openQV  = openQV;
  window.closeQV = closeQV;

}());